
const accessRoles = {
  ADMIN: 'admin',
  MAGDALA_ADMIN: 'magdala-admin'
};

const allRoles = [accessRoles.ADMIN, accessRoles.MAGDALA_ADMIN];

const config = {
  notificationMessageLimit: 300,
  wpTimeout: 30000,
  emptyFn: () => {},

  courseNotComplete: ['pending', 'registered', 'started'],
  courseComplete: ['complete', 'archived', 'archived-recorded'],
  courseArchived: ['archived', 'archived-recorded'],
  courseRegistered: 'registered',
  courseRecordOnly: 'archived-recorded',
  courseStatus: {
    'pending': 'Pending Registration, Error', 
    'registered': 'Registered, Not Started', 
    'started': 'In Progress', 
    'complete': 'Completed', 
    'archived': 'Archived', 
    'archived-recorded': 'Archived, Record Only'
  },

  monthNames: [
    "January", "February", "March", "April", "May", "June", "July", 
    "August", "September", "October", "November", "December"
  ],

  pdf: {
    defaultTextColor: '#102B4E',
    dateFont: {
      url: '/fonts/Tangerine-Bold.ttf',
      file: 'Tangerine-Bold.ttf',
      name: 'Tangerine',
      size: 35,
      fallbackFont: 'times',
      fallbackStyle: 'italic',
      fallbackSize: 22
    },
    nameFont: {
      url: '/fonts/MrsSaintDelafield-Regular.ttf',
      file: 'MrsSaintDelafield-Regular.ttf',
      name: 'MrsSaintDelafield',
      size: 55,
      fallbackFont: 'times',
      fallbackSize: 44
    },
    landscape: [11, 8.5],
    certificatePage1: {
      dateLocationFn: (dateWidth) => [2.67-(dateWidth/2), 6.88],
      nameLocationFn: (nameWidth) => [5.5-(nameWidth/2), 3.6]
    }
  },

  accessRoles,
  routeAccess: { // note: anything not listed here will only be available to ADMIN role
    '/dashboard': allRoles,
    '/course/attendance': allRoles
  }
};

export default config;